export const InvoicePaths = {
	List: {
		route: "/invoices",
		path: "/invoices",
	},
};
